import { useCallback, useEffect, useState, useRef } from 'react';

export function useTextOverflow(text: string, tooltip: boolean) {
    const contentRef = useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    const measureTextWidth = (text: string, font: string) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (context) {
            context.font = font;
            return context.measureText(text).width;
        }
        return 0;
    };

    const checkTextOverflow = useCallback(
        (element: HTMLDivElement) => {
            const style = getComputedStyle(element);
            const font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
            const textWidth = measureTextWidth(text, font);
            return textWidth > element.clientWidth;
        },
        [text],
    );

    useEffect(() => {
        if (tooltip && contentRef.current) {
            const isTextTruncated = checkTextOverflow(contentRef.current);
            setIsOverflowing(isTextTruncated);
        }
    }, [checkTextOverflow, tooltip]);

    return { contentRef, isOverflowing };
}
